export enum ResponseEnum {
  msgSuccess = "Success",
  statusSuccess = 0,
  statusErrorLogin = 120,
  msgLogoutSuccess = "Logout successful",
  codeCancelRequest = "ERR_CANCELED",
  msgErrorProvider = "Invalid Provider",
  uploadSuccess = "Uploaded Successfully",
  pendingStatus = "Pending",
  completeStatus = "Complete",
  cancelStatus = "Cancel",
  runningStatus = "Running",
  trueStatus = "TRUE",
  falseStatus = "FALSE",
  msgLoginError = "Username does not exist",
}
